module.exports = __webpack_public_path__ + "img/12_bohle.5a653564.jpeg";